import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal, InputGroup } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
//import classes from "../../Styles/common.module.css";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RegisterTicketCategory = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);

	const ticketCatInputRef = useRef();
	const remarkInputRef = useRef();

	const [dataToBeSelect, setDataToBeSelect] = useState([]);

	const [addData, setAddData] = useState([]);
	const [inputError, setInputError] = useState([]);

    const hideModal = () => {
		setAddData([]);
		setInputError([]);
		props.onHide();
	};

	const saveBtnOnClick = () => {
		var flag = true;
		if (addData.TICKET_CATEGORY_NAME === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				TICKET_CATEGORY_NAME: ("Ticket category name could not be empty."),
			}));
		}
        if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			RegisterTicketCategory();
		}
	}

    function RegisterTicketCategory() {
		let functionName = "";
		try {
			functionName = props.page + RegisterTicketCategory.name;
			props.onLoading(true, "Registering ticket category, please wait...");
			const data = {
				TICKET_CATEGORY_NAME: addData.TICKET_CATEGORY_NAME,
				REMARK: addData.REMARK === undefined ? "" : addData.REMARK,
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};
			http
				.post("api/TicketCategory/RegisterTicketCategory", data, { timeout: 10000 })
				.then((response) => {
					if (response.data.DUPLICATE_TICKET_CATEGORY_NAME === true) {
						toast.error("Ticket category already exist.");
					} else {
						toast.success("Ticket category is successfully inserted.");
						props.onReload();
						hideModal();
					}
				})
				.catch((err) => {
					toast.error("Failed to insert Ticket category. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to insert Ticket category. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

    const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setAddData((prevState) => ({
				...prevState,
				[id]: val,
			}));           
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

	const inputUnrequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputUnrequiredHandler.name;
			const name = event.target.name;
			functionName = inputUnrequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;

			setAddData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

    return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "lightgrey", width: "100%" }}>
						<Modal.Title>REGISTER</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Comp.Input
						ref={ticketCatInputRef}
						id="TICKET_CATEGORY_NAME"
						label="Ticket Category Name*:"
						name="Ticket Category Name"
						type="text"
						className="form-control"
						errorMessage={inputError.TICKET_CATEGORY_NAME}
						value={addData.TICKET_CATEGORY_NAME}
						onChange={inputRequiredHandler}
					/>
                    <Comp.Input
						ref={remarkInputRef}
						id="REMARK"
						label="Remark:"
						type="text"
						className="form-control"
						value={addData.REMARK}
						onChange={inputUnrequiredHandler}
					/>
				</Modal.Body>
				<Modal.Footer>
					<div style={{ textAlign: "center", width: "100%" }}>
						<Comp.Button id="btnSave" onClick={saveBtnOnClick}>
							Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={hideModal}
						>
							Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default RegisterTicketCategory;